export class StatutUO {
  constructor(
    public id: number,
    public libelleStatusUo: string,
    public dateDebut: Date,
    public dateFin: Date
  ) { }
}
